export const dealsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_DEALS_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        deals: null,
      };
    }
    case "GET_DEALS_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        deals: action.payload,
      };
    }
    case "GET_DEALS_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        deals: action.payload,
      };
    }
    case "ADD_DEALS_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        deals: null,
      };
    }
    case "ADD_DEALS_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        deals: action.payload,
      };
    }
    case "ADD_DEALS_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        deals: action.payload,
      };
    }
    case "GET_DEAL_REQUEST": {
      return {
        ...state,
        loading: true,
        deal: null,
      };
    }
    case "GET_DEAL_SUCCESS": {
      return {
        ...state,
        loading: false,
        deal: action.payload,
      };
    }
    case "GET_DEAL_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case "UPDATE_DEAL_REQUEST": {
      return {
        ...state,
        loading: true,
        updatedDeal: null,
      };
    }
    case "UPDATE_DEAL_SUCCESS": {
      return {
        ...state,
        loading: false,
        updatedDeal: action.payload,
      };
    }
    case "UPDATE_DEAL_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
